<nb-card>
  <nb-card-header class="header-category" [style.background-color]="styleConfig.backgroundColor">
    <div class="featured-category" *ngIf="!newSearchLoading && !loadingStyle">
      <div class="featured-category-item">
        <h3 [style.color]="styleConfig.color" (click)="goToCategory()" class="featured-category-name">{{ category.name |
          titlecase }}</h3>
        <!-- <h3 [style.color]="styleConfig.color" (click)="goToCategory()" class="featured-category-name">Teste</h3> -->
      </div>
    </div>
  </nb-card-header>
  <nb-card-body class="body-category">
    <div class="featured-category-item">
      <div class="col my-3" style="text-align: center;" *ngIf="firstLoading">
        <div><p-progressSpinner></p-progressSpinner></div>
        <div>Carregando produtos...</div>
      </div>
      <ng-container *ngIf="!firstLoading && !loadingStyle">
        <p-dataView #dv [value]="products" [paginator]="false" [rows]="pageSize" filterBy="name"
          [sortOrder]="onSortOrderEmit" listItemTemplate layout="grid" [lazy]="true"
          emptyMessage="Não existem produtos para a categoria selecionada" [totalRecords]="totalRecords">
          <ng-template pTemplate="header">
            <div class="row p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
              <div class="col">
                <p-dropdown [options]="sortOptions" [(ngModel)]="sortOption" placeholder="Ordenar por "
                  (onChange)="onSortChange($event.value)" styleClass="p-mb-2 p-mb-md-0"></p-dropdown>
              </div>
            </div>
          </ng-template>

          <!--Grid de Produtos-->
          <ng-template let-product pTemplate="gridItem">
            <div class="p-md-2">
              <div class="product-grid-item card">
                <!-- Header -->
                <div class="product-grid-img" (click)="goToDetails(product)">
                  <p-skeleton *ngIf="!product.link"></p-skeleton>
                  <img *ngIf="product.link" class="img-fluid" [src]="product.link" [alt]="product.name" />
                </div>
                <!-- Conteúdo -->
                <div class="product-grid-item-content" (click)="goToDetails(product)">
                  {{ getProductName(product) | titlecase }}
                  <div *ngIf="showMeasurementUnitDescription(product)" class="text-center mt-1">
                    {{ product.measurementUnitDescription | titlecase }}
                  </div>
                </div>


                <!-- Footer -->
                <div class="product-grid-item-bottom">
                  <div class="justify-content-center h-100 p-fluid">
                    <discount-info [product]="product" [indexPrice]="product.measurementUnitIndex"
                      [measurementQuantity]="product.measurementUnitQuantity"
                      class="d-flex justify-content-center"></discount-info>
                    <div class="py-2">
                      <div *ngIf="product.selectedMeasurementUnit != null && product.selectedMeasurementIndex != null"
                        class="product-price">
                        {{ ((product.offerPrice == 0 ? product.price : product.offerPrice) *
                        product.selectedMeasurementIndex) * product.selectedMeasurementQuantity | currency:'BRL' }}
                      </div>
                      <div *ngIf="product.selectedMeasurementUnit != null && product.selectedMeasurementIndex == null"
                        class="product-price">
                        {{ (product.offerPrice == 0 ? product.price : product.offerPrice) *
                        product.selectedMeasurementQuantity | currency:'BRL' }}
                      </div>
                      <div *ngIf="product.selectedMeasurementUnit == null" class="product-price">
                        {{ ((product.offerPrice == 0 ? product.price : product.offerPrice) *
                        product.measurementUnitIndex)
                        * product.measurementUnitQuantity | currency:'BRL' }}
                      </div>
                    </div>
                    <div class="py-2 unit-price">
                      <custom-input-number (productChange)="updateProduct($event)" [product]="product"
                        [styleConfig]="styleConfig"
                        [measurementUnit]="buildListElementMeasurementUnit(product)"></custom-input-number>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </ng-container>

      <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" #paginator
        (onPageChange)="pageEmit($event)"></p-paginator>
    </div>
  </nb-card-body>
</nb-card>